
import * as React from "react";
import './Pagination.scss';

interface PaginationClientProps {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
    pageSizeOptions?: number[];
}

const pageSizeCollection = [5, 10, 20, 30, 40, 50, 100];

const PaginationClient: React.FC<PaginationClientProps> = ({
    currentPage,
    totalPages,
    pageSize,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = pageSizeCollection,
}) => {
    return (
        <nav className="pagination-container">
            <ul className="pagination">
                <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(1)} disabled={currentPage === 1}>
                        <i className="icon angle-right-back fa-lg" aria-hidden="true" />
                    </button>
                </li>
                <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                        <i className="icon angle-left fa-lg" aria-hidden="true" />
                    </button>
                </li>
                <li className="page-item">
                    <span className="page-link" style={{ cursor: 'default' }}>
                        {currentPage} / {totalPages}
                    </span>
                </li>
                <li className={`page-item${currentPage === totalPages || totalPages === 0 ? ' disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                        <i className="icon angle-right fa-lg" aria-hidden="true" />
                    </button>
                </li>
                <li className={`page-item${currentPage === totalPages || totalPages === 0 ? ' disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages || totalPages === 0}>
                        <i className="icon angle-right-next fa-lg" aria-hidden="true" />
                    </button>
                </li>
            </ul>
            <div className="page-size">
                <select className="form-control" value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))}>
                    {pageSizeOptions.map((size, ind) => (
                        <option key={ind} value={size}>{size}</option>
                    ))}
                </select>
                <div className="item-per-page">Items per page</div>
            </div>
        </nav>
    );
};

export default PaginationClient;
